<template>
  <div class="ma-3 ml-3 site_content">
    <div class="title">
      <div class="flex align-center">
        <img class="notice_icon" :src="require('@/assets/client/notice.svg')" />
        <span class="title_text">공지사항</span>
      </div>

      <div class="notice">
        원스프링에서 제공하는 공지사항입니다.
      </div>
   
    </div>

    <div class="table_layout mt-3">
      <v-data-table  dense height="650"
          :loading="loading"
          id="time__table"
          fixed-header
          :items-per-page="-1" 
          :footer-props="{
            itemsPerPageOptions:[-1]
          }"
          :headers="headers"
          :items="items"
          no-data-text="등록된 공지사항이 없습니다."
          class="table_content"
          item-key="id"
          single-select
          hide-default-footer
          :sort-by= "['regdate','id']"
          :expanded.sync="expanded"
          @click:row="toggleExpand"
        >
        <template v-slot:item="{ item }">
          <tr @click="toggleExpand(item)" :class="{ 'selected-row': selectedId === item.id }">
            <td style="text-align: center;">{{ item.id }}</td>
            <td style="text-align: center;">{{ item.title }}</td>
            <td style="text-align: center;">{{ item.regname }}</td>
            <td style="text-align: center;">{{ item.regdate }}</td>
          </tr>

          <tr v-if="selectedId === item.id">
            <td :colspan="headers.length" class="expand-section">
              <div class="expand-box">
                {{ item.contents }}
              </div>
              <div class="btn-section mb-3">
                <v-btn class="update-btn" @click="updateContents(item)" style="color:white !important;" v-show="$getters.userInfo.grade == 'UT01'">수정하기</v-btn>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>

   
    <v-dialog
      v-model="updateDialog"
      width="550px">
      <v-card width="550px">
       <div class="dialog-title"> 공지사항 수정 </div>

       <div class="dialog-content">
        <div class="flex" style="align-items: center;">
          <div class="dialog-detail-title">제목</div>
          <v-text-field dense outlined
            style="max-width:30vw;"
            class="textfield"
            id="title" 
            ref="title" 
            v-model="value.title"
          />
        </div>


        <div class="flex mt-3 s-bt a-center">
          <div class="flex ">
            <div class="dialog-detail-title">작성자</div>
            <div class="gray mr-15"> {{ value.regname }}</div>
          </div>

          <div class="flex a-center">
            <div class="dialog-detail-title ml-10">게시기간</div>
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="10"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field dense outlined clearable class="textfield shrink " style="max-width:180px;"
                  id="until" 
                  ref="until" 
                  v-model="value.util"
                  label=""
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title locale="ko-KR"
                v-model="value.util"
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
          </div>
        </div>

        <div class="mt-3">
          내용
          <v-textarea
              v-model="value.contents"
              outlined
              class="textarea"
              rows="6"
              height="250px"
              required
            />
        </div>

        <div class="btn-section">
          <v-btn 
            class="normal-btn" @click="updateNotice(value)"
            text
            id="save" 
            ref="save" 
            type="submit" 

          >
            수정하기
          </v-btn>
        </div>

       </div>
      </v-card>
    </v-dialog>

    <div class="btn-section" v-show="$getters.userInfo.grade == 'UT01'">
      <v-btn
          @click="insertDialog = true"
          class="normal-btn"
          text
          id="save" 
          ref="save" 
          type="submit" 
        >
          글쓰기
        </v-btn>
    </div>

    <v-dialog
      v-model="insertDialog"
      width="550px">
      <v-card width="550px">
       <div class="dialog-title"> 공지사항 등록 </div>

       <div class="dialog-content">
        <div class="flex" style="align-items: center;">
          <div class="dialog-detail-title">제목 *</div>
          <v-text-field dense outlined
            style="max-width:30vw;"
            class="textfield"
            id="title" 
            ref="title" 
            v-model="title"
          />
        </div>


        <div class="flex mt-3 s-bt a-center">
          <div class="flex a-center">
            <div class="dialog-detail-title">게시기간</div>
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="10"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field dense outlined clearable class="textfield shrink " style="max-width:180px;"
                  id="until" 
                  ref="until" 
                  v-model="util"
                  label=""
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title locale="ko-KR"
                v-model="util"
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </div>
        </div>

        <div class="mt-3">
          내용 *
          <v-textarea
              v-model="contents"
              outlined
              class="textarea"
              rows="6"
              height="250px"
              required
            />
        </div>

        <div class="btn-section">
          <v-btn 
            class="normal-btn" @click="insertNotice()"
            text
            id="save" 
            ref="save" 
            type="submit" 

          >
            등록하기
          </v-btn>
        </div>

       </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import Common from "@/utils/custom/common.js";
import Apis from '@/api/apis'

export default {
  name: 'Notice',

  data: () => ({
    headers: [
        { text: '번호', align: 'center', value: 'id', filterable: true, sortable: true, groupable: false, width: "10px", show: true,divider: true},
        { text: '제목', align: 'center', value: 'title', filterable: true, sortable: true, groupable: false, width: "300px", show: true,divider: true},
        { text: '작성자', align: 'center', value: 'regname', filterable: true, sortable: true, groupable: false, width: "18px", show: true,divider: true},
        { text: '작성날짜', align: 'center', value: 'until', filterable: true, sortable: true, groupable: false, width: "120px", show: true,divider: true},
      ],
    items:[],
    loading : false,
    expanded: [],
    selectedId: null,

    updateDialog:false,

    title:'',
    value:{},

    menu1:false,
    until:'',

    menu2:false,
    util:'',
    contents:'',

    insertDialog:false,



  }),
  created(){
    Apis.pageCount({
      page_name: this.$route.name,
      url: this.$route.path,
      division: "cloud",
    },() => {  // 정상처리
      // console.log("pageCount 호출",res);
    }).catch( (err) => {  // 개별 API 오류 처리 예제
      console.log("pageCount 호출 오류",err);
    });

    this.refresh();

  },
  methods:{
    toggleExpand(item) {
      this.selectedId = this.selectedId === item.id ? null : item.id;
    },
    updateContents(value){
      this.updateDialog = true;
      this.value=value
      // console.log(value)
    },
    updateNotice(value){
      // console.log(value)
      Apis.updateNotice({
        "register_no": value.register_no,
        "title": value.title,
        "contents": value.contents,
        "until": value.util || "",
        },(res) => {  
          // console.log(res)
          if (res.result) {
            this.$store.commit("resMessage", res.message);

            this.updateDialog = false;
            this.refresh();
            

          } else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("updateNotice API 호출 오류",err)
            alert(err);
        }
      )
    },
    insertNotice(){
      Apis.insertNotice({
        "title": this.title,
        "contents": this.contents,
        "until": this.util || "",
        },(res) => {  
          // console.log(res)
          if (res.result) {
            this.$store.commit("resMessage", res.message);
            
            this.title = "",
            this.contents = "",
            this.until = "",
            
            this.insertDialog = false;
            this.refresh();

            

          } else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("updateNotice API 호출 오류",err)
            alert(err);
        }
      )
    },
    refresh(){
      this.loading = true;

      Apis.listNotices({
        },(res) => {  
          // console.log(res)
          if (res.result) {
            this.items = res.data;
            this.loading = false;

          } else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("API 호출 오류",err)
            alert(err);
        }
      ) 
    }
  }
}
</script>

<style scoped  lang="scss">
@import '../../style/base.scss';
@import '../info/info_style/info_style.scss';
.notice_icon{
  max-width:45px;
}
.title_text{
  letter-spacing: -1px;
  font-weight:600;
  color:$main-color;
  font-size:22px;
}
.notice{
  font-size:16px;
  letter-spacing: -1.25px;
  color:#8f8f8f;
}
.site_content{
  display:flex;
  flex-direction: column;
  height:90vh;
  justify-content: center;
  // align-items: center;
}
.table_layout{
  border-radius: 30px !important;
  padding:0 !important;
  margin-top:10px;
  height:650px;
  min-height:250px;
}
.normal-btn{
  color:white !important;
  font-size:16px;
  letter-spacing: -1px;
  background-color: $main-color !important;
  font-weight:600;
  width:95px !important;
  height:45px !important; 
  border-radius: 30px;
  box-shadow: 2px 3px 4px 0px #bebebe !important;
}
.update-btn{
  border-radius: 20px !important;
  background-color: #bebebe !important;
}
.btn-section{
  display: flex;
  justify-content:right;
  margin-top:10px;
}
::v-deep .selected-row {
  background-color: #E8F3F5 !important;
}
::v-deep .expand-section{
  background-color: #E8F3F5 !important;
}
.expand-box {
  width:100%;
  padding: 20px;
}
.dialog-title{
  background-color: $main-color;
  padding:10px;
  font-size:1.2rem;
  color:white;
  font-weight:550;
  letter-spacing: -1px;
}
.dialog-content{
  padding:20px;
}
.gray{
  color:#8f8f8f;
}
.dialog-detail-title{
  width:75px;
}
.textarea{
  min-height:250px;
}
</style>
